import { Injectable, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { MetadataService } from '../metadata/metadata';
import { OfflineSessionService } from '../offline/offline-session';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private readonly translateService = inject(TranslateService);
  private readonly metadataService = inject(MetadataService);
  private readonly offlineSession = inject(OfflineSessionService);

  readonly lang = toSignal(this.translateService.onLangChange.pipe(map((event) => event.lang)), {
    initialValue: 'en',
  });

  constructor() {
    effect(() => {
      const metadata = this.metadataService.metadata();
      if (metadata) {
        const { userLanguage } = metadata.config;
        this.translateService.use((userLanguage || this.translateService.getBrowserLang()) ?? 'en');
        return;
      }
      // Without metadata the messages that explain why still need a language.
      if (this.metadataService.isUnauthorized() || this.offlineSession.blockReason()) {
        this.translateService.use(this.translateService.getBrowserLang() ?? 'en');
      }
    });
  }
}
